module.exports = __webpack_public_path__ + "img/view-list.4d6d6f2d.svg";